export const BOOKING_POLICY_URL = "/booking-policy";

export type CancellationPolicyDisplay = {
  label: "Refundable" | "Non-refundable";
  summary: string;
};

export function courseCancellationPolicy(
  isNonRefundable: boolean
): CancellationPolicyDisplay {
  return isNonRefundable
    ? {
        label: "Non-refundable",
        summary: "Cancellations are non-refundable.",
      }
    : {
        label: "Refundable",
        summary: "Free cancellation up to 7 days before the activity.",
      };
}
